var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-container',[_c('Header'),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6005d50f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","b-avatar":"src","b-img":"src","b-img-lazy":["src","blank-src"],"b-card":"img-src","b-card-img":"src","b-card-img-lazy":["src","blank-src"],"b-carousel-slide":"img-src","b-embed":"src"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = V9tw
// module chunks = 1